/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Agreement } from "./Agreement";
export type CreatePermitOutcome = {
  details: {
    agreement: Agreement;
  };
  result: CreatePermitOutcome.result;
} | {
  details: {
    available_capacity: number;
  };
  result: CreatePermitOutcome.result;
} | {
  result: CreatePermitOutcome.result;
};
export namespace CreatePermitOutcome {
  export enum result {
    OK = "ok",
  }
}
